export default __webpack_public_path__ + "static/media/5498.51cc28d7.png";